import React, { useEffect, useRef, useState } from 'react';
import axios from "axios";
import classnames from "classnames";
import { mobileCheck } from "../../../../Map/resources/js/utility/mobileDetection";
import PropTypes from "prop-types";
import useSWRImmutable from 'swr/immutable'
import 'react-loading-skeleton/dist/skeleton.css'
import SearchResultsList from "./SearchResultsList";
import SearchTypeMenuBar from "./SearchTypeMenuBar";
import SearchKeywordBar from "./SearchKeywordBar";

const SearchNavigationBar = props => {
    const {
        onSearchHide,
    } = props;

    const [searchKeyword, setSearchKeyword] = useState(null);
    const [searchTypes, setSearchTypes] = useState([]);
    const [isMobile, setIsMobile] = useState(mobileCheck());
    const [isResultShowing, setResultShow] = useState(false);

    const resultDivRef = useRef(null);

    const { data: results = {}, error, isLoading } = useSWRImmutable(
        ['/api/search' ,searchTypes, searchKeyword],
        async ([route, _types,  _keyword]) => {
            if (!_keyword || !_types.length) return {};
            const results = await axios.get(route, { params: { keyword: _keyword, type: _types } });
            return results?.data.data;
        },
    );

    // resize when window changes
    useEffect(() => {
        const resizeListener = (e) => setIsMobile(mobileCheck());
        window.addEventListener('resize', resizeListener);
        return () => window.removeEventListener('resize', resizeListener);
    },[]);

    // attach mouse click and keyboard handler for escape
    useEffect(() => {
        if (!resultDivRef?.current) return;
        const handleClickOutside = (event) => {
            if (!resultDivRef?.current.contains(event.target)) setResultShow(false);
        };
        const handleEscapePress = (event) => {
            if (event.key === "Escape") setResultShow(false);
        }
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEscapePress);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscapePress);
        };
    }, [resultDivRef?.current]);

    // show result div when the keyword is updated
    useEffect(() => {
        if(searchKeyword) setResultShow(true);
    }, [searchKeyword]);

    const handleCancelClick = () => {
        setSearchKeyword(null);
        onSearchHide();
    };

    return (
        <div className="position-relative">
            <div className="d-flex align-items-center bg-dark rounded p-2">
                <div className={classnames(isMobile ? "w-100" : "w-50")}>
                    <SearchKeywordBar
                        isLoading={isLoading}
                        searchKeyword={searchKeyword}
                        setSearchKeyword={v => setSearchKeyword(v)}
                        onCancelClick={handleCancelClick}
                    />
                </div>
            </div>

            <div
                ref={resultDivRef}
                className={classnames(
                    "position-absolute px-1 mt-2 rounded overflow-auto d-flex flex-column",
                    isMobile ? "w-100" : "w-50",
                    { "d-none": !isResultShowing }
                )}
                style={{ zIndex: 99999, height: "40vh", backgroundColor: "#2d3237" }}
            >
                <div className="my-2 ps-2">
                    <SearchTypeMenuBar
                        onSearchTypesChange={(types) => setSearchTypes(types)}
                    />
                </div>

                <div
                    className="flex-grow-1"
                    style={{ zIndex: 999999, backgroundColor: "#2d3237" }}
                >
                    <SearchResultsList
                        isLoading={isLoading}
                        results={results}
                        isSelectedTypesEmpty ={searchTypes.length === 0}
                    />
                </div>
            </div>
        </div>
    );
};

SearchNavigationBar.propTypes = {
    onSearchHide: PropTypes.func.isRequired,
};

export default SearchNavigationBar;
